export default "__VITE_ASSET__DY3Pc1fG__"